import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState: {
    formShown: false,
  },
  reducers: {
    toggleForm: (state) => {
      state.formShown = !state.formShown;
    },
  },
});

export const { toggleForm } = feedbackSlice.actions;
export const getFeedbackFormState = (state: RootState) =>
  state.feedback.formShown;
export default feedbackSlice.reducer;
